module.exports = __webpack_public_path__ + "img/sort-legal-for-sale.2f2f7575.png";